// extracted by mini-css-extract-plugin
export var buttonContainer = "_85-1";
export var fontSizeSelect = "_85-3";
export var formatSelect = "_85-2";
export var formats = "_85-4";
export var hidden = "_85-5";
export var icon = "_85-6";
export var select = "_85-0";